import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchCategories = async (params) => {
  const path = '/categories/';

  const response = await axiosInstance.get(path, {
    params,
  });
  return response.data;
};

export const useGetCategoriesList = (params = {}, options = {}) => {
  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [params]);

  const { data, error, isLoading, isError, refetch } = useQuery({
    queryKey: ['categories', queryParams],
    queryFn: () => fetchCategories(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });

  const categories = data?.results;

  return { categories, error, isLoading, isError, refetch };
};
